import { X } from "lucide-react";
import { useEffect } from "react";

import { SidebarContent } from "@/components/layout/sidebar";
import { Logo } from "@/components/ui/logo";

export function MobileNav({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] xl:hidden" role="dialog" aria-modal="true" aria-label="Menú">
      <button aria-label="Cerrar menú" className="absolute inset-0 bg-black/40" onClick={onClose} type="button" />
      <aside className="absolute inset-y-0 left-0 flex w-[300px] max-w-[85vw] flex-col overflow-y-auto bg-white shadow-xl dark:bg-[#101315]">
        <div className="flex h-[100px] shrink-0 items-center justify-between border-b border-[#dfe3eb] px-6 dark:border-[#2e3336]">
          <Logo markClassName="h-10 w-10" textClassName="dark:text-white" />
          <button
            aria-label="Cerrar menú"
            className="grid h-10 w-10 place-items-center rounded-full border border-[#dfe3eb] dark:border-[#3f4548]"
            onClick={onClose}
            type="button"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <SidebarContent onNavigate={onClose} />
      </aside>
    </div>
  );
}
